module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "default",
    attrs: {
      "id": "d8e56NaN"
    }
  }), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d7e141"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("by"), _c('br'), _vm._v("Amberle Cianne ")])])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bkt",
    attrs: {
      "id": "d7e91"
    }
  }, [_c('b', [_vm._v("Nightmare in Niceville ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4033af01","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cian_9781937084424_epub_c2_r1.vue
// module id = 57
// module chunks = 0